import { css, useTheme } from '@emotion/react';

export default function InitialLoading() {
  const theme = useTheme();
  return (
    <div
      css={css`
        display: flex;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        align-items: center;
        justify-content: center;
        background: ${theme.backgroundColor.base};
      `}
    >
      <span
        css={css`
          color: ${theme.themeColor.main_light};
          ${theme.fontStyle.poppins.desc2};
        `}
      >
        Loading...
      </span>
    </div>
  );
}
